<template>
	<div class="edit-info content">
		<el-page-header @back="goBack" content="修改信息"></el-page-header>
		
		<div class="flex-text flex-v" style="margin: 80px 0;">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px">
				<el-form-item label="上传头像：" prop="avatar">
				    <el-upload
				      class="avatar-uploader"
				      :action="baseURL + '/api/webs/account/upload'"
					  :headers="{ 'Token': token, 'System-Key': match }"
				      :show-file-list="false"
				      :on-success="handleAvatarSuccess">
					  <el-image v-if="form.avatar" class="avatar" :src="form.avatar" fit="cover"></el-image>
				      <el-image v-else class="avatar" :src="require('@/static/avatar.png')" fit="cover"></el-image>
				    </el-upload>
				</el-form-item>
				<el-form-item class="mt25" label="昵称：" prop="name">
				    <el-input maxlength="18" v-model="form.name" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<div class="mt25">
					<el-button class="" style="margin-left: 100px;" type="primary" @click="submitForm('form')" :loading="isLoading">确认修改</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return{
			baseURL: process.env.VUE_APP_BASE_API,
			match: null,
			
			form: {
				avatar: '',
				name: ''
			},
			rules: {
				avatar: [
					{ required: true, message: '请上传头像', trigger: 'change' }
				],
				name: [
					{ required: true, message: '请输入昵称', trigger: 'blur' },
				]
			}
		}
	},
	mounted(){
		this.form.avatar = this.userInfo.header
		this.form.name = this.userInfo.nick
		
		const regex = /^(?:https?:\/\/)?(?:[^\/]+)\/([^\/#]+)/i;
		const match = window.location.href.match(regex);
		this.match = match ? match[1] : null
	},
	methods: {
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
			    if (valid) {
					this.isLoading = true
					
					let params = {
						nick: this.form.name,
						header: this.form.avatar
					}
					this.$http.post('/api/webs/account/setMy', params)
					    .then(response => {
					        let res = response.data
							
							this.isLoading = false
							this.getUser()
							this.$message({ message: '用户信息更新成功', type: 'success' })
					    })
					    .catch(error => {
					        console.error(error)
					    })
			    } else {
			        console.log('error submit!!');
			        return false;
			    }
			});
		},
		
		handleAvatarSuccess(res, file) {
			this.form.avatar = process.env.VUE_APP_BASE_API + res.data.path
		},
			
		goBack(){
			this.$router.go(-1)
		}
	}
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #00a1ff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.avatar {
    width: 100px;
    height: 100px;
    display: block;
}
.edit-info .el-input{
	width: 400px !important;
}
</style>